(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steeque-all-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-stq-rp]').forEach(function (root) {
    var panel = root.querySelector('[data-stq-panel]');
    var toggles = root.querySelectorAll('[data-stq-toggle]');
    var grid = root.querySelector('[data-stq-grid]');
    var load = root.querySelector('[data-stq-load]');
    var shown = root.querySelector('[data-stq-shown]');
    var step = 24;
    var filter = 'all';
    var limit = step;

    var months = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };

    function stamp(card) {
      var el = card.querySelector('.stq-rp__date');
      if (!el) return 0;
      var parts = el.textContent.trim().split(/\\s+/);
      var m = months[(parts[0] || '').slice(0, 3).toLowerCase()];
      var y = parseInt(parts[1], 10);
      if (isNaN(y) || m === undefined) return 0;
      return y * 12 + m;
    }

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.stq-rp__card'));
    cards.sort(function (a, b) { return stamp(b) - stamp(a); });
    var frag = document.createDocumentFragment();
    cards.forEach(function (c) { frag.appendChild(c); });
    grid.appendChild(frag);

    function pool() {
      return filter === 'all' ? cards : cards.filter(function (c) { return c.dataset.r === filter; });
    }

    function paint() {
      var list = pool();
      cards.forEach(function (c) { c.classList.add('is-hidden'); });
      list.slice(0, limit).forEach(function (c) { c.classList.remove('is-hidden'); });
      var visible = Math.min(limit, list.length);
      if (shown) shown.textContent = 'Showing ' + visible + ' of ' + list.length + ' reviews';
      if (load) load.style.display = visible >= list.length ? 'none' : '';
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        var open = panel.hasAttribute('hidden');
        if (open) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
        root.querySelectorAll('[aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
      });
    });

    root.querySelectorAll('[data-stq-filter]').forEach(function (b) {
      b.addEventListener('click', function () {
        filter = b.dataset.stqFilter;
        limit = step;
        root.querySelectorAll('[data-stq-filter]').forEach(function (x) { x.classList.remove('is-active'); });
        if (filter !== 'all') b.classList.add('is-active');
        paint();
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (load) {
      load.addEventListener('click', function () {
        limit += step;
        paint();
      });
    }

    paint();
  });

  } catch(e) { console.error(e); }
})();
})();
